import { ISuitabilityReportData } from "@portal/types/robot/ISuitabilityReportData";
import { ISavingAgreementData } from "@portal/types/robot/ISavingAgreementData";
import { IRiskLevel } from "@portal/types/robot/IRiskLevel";
import { Language } from "@portal/types/robot/IRobotEnums";
import { ICustomerInfo } from "@portal/types/api/ICustomerInfo";
import { ICreateSavingsAgreement } from "@portal/types/api/ICreateSavingsAgreement";
import { CalculateStartUpAmountForFund } from "./GetStartUpAgreementRequest";
import { format } from "date-fns";

export const GetSuitabilityReport = (
  centerId: string,
  savingsAgreementRequest: ICreateSavingsAgreement,
  isDefaultLanguage: boolean,
  requestAgreementData: ISavingAgreementData,
  riskLevelRequest: IRiskLevel,
  customerInfo?: ICustomerInfo,
  summedFee?: number,
) => {
  const suitabilityReportRequest = {
    customerNumber: customerInfo?.contactInfo.customerNumber,
    firstName: customerInfo?.firstname,
    lastName: customerInfo?.lastName,
    monthlyAmount: requestAgreementData.monthlyAmount,
    riskLevel: requestAgreementData.riskLevel,
    sustainability: requestAgreementData.sustainability,
    language: isDefaultLanguage ? Language.NB : Language.NN,
    summedFee: summedFee,
    answers: {
      savingPeriod: riskLevelRequest.savingPeriod,
      riskAppetite: riskLevelRequest.riskAppetite,
      behaviour: riskLevelRequest.behaviour,
      savingsToday: riskLevelRequest.savingsToday,
      sharesToday: riskLevelRequest.sharesToday,
      experience: riskLevelRequest.experience,
      relevantEduationOrJob: riskLevelRequest.relevantEduationOrJob,
      sustainability: riskLevelRequest.sustainability,
      sustainabilityEu: riskLevelRequest.sustainabilityEu,
      sustainabilityPai: riskLevelRequest.sustainabilityPai,
      sustainabilitySfdr: riskLevelRequest.sustainabilitySfdr,
      originallyWantedSustainabilitySfdr: riskLevelRequest.originallyWantedSustainabilitySfdr,
      originallyWantedSustainabilityPai: riskLevelRequest.originallyWantedSustainabilityPai,
      originallyWantedSustainabilityEu: riskLevelRequest.originallyWantedSustainabilityEu,
      availableLiquidity: riskLevelRequest.availableLiquidity,
      moreValuesThanDebt: riskLevelRequest.moreValuesThanDebt,
      savingOfTotalEconomy: riskLevelRequest.savingOfTotalEconomy,
      centerId: centerId,
    },
    oneTimePaymentInfo:
      requestAgreementData.oneTimeDeposit > 0
        ? {
            bankAccountNumber: savingsAgreementRequest.agreementData.cashAccount,
            funds: savingsAgreementRequest.agreementData.funds.map(fund => ({
              amount: CalculateStartUpAmountForFund(requestAgreementData.oneTimeDeposit, 1, fund),
              fundName: fund.name,
            })),
          }
        : undefined,
    savingsAgreementInfo:
      requestAgreementData.monthlyAmount > 0
        ? {
            bankAccountNumber: savingsAgreementRequest.agreementData.otherCashAccount
              ? savingsAgreementRequest.agreementData.otherCashAccount
              : savingsAgreementRequest.agreementData.cashAccount,
            endDate: savingsAgreementRequest.agreementData.dateTo
              ? format(new Date(savingsAgreementRequest.agreementData.dateTo), "yyyy-MM-dd")
              : null,
            funds: savingsAgreementRequest.agreementData.funds.map(fund => ({
              amount: fund.amount,
              fundName: fund.name,
            })),
          }
        : undefined,
  } as ISuitabilityReportData;

  return suitabilityReportRequest;
};
